import { StreamManager } from 'openvidu-browser';
import VideoPlayer from './BroadcastVideoPlayer';
import {useEffect, useState } from 'react';


interface Props {
    user: StreamManager,
    mediaStream?: MediaStream,
    userId: string,
    fullScreen?: boolean,
    isGrabber : boolean,
    onlyVideo?: boolean,
    videoClassName?: string,
    onlyAudio?: boolean,
    audioClassName?: string,
    title?: string,
    handRaised? : boolean,
    isMicrophoneActive? : boolean,
    isCameraActive? : boolean,
    mirror? : boolean,
    toggleSingleFullScreen? : (id? : string) => void,
}

const BroadcastStreamingContainer = ({ user, userId, fullScreen, isMicrophoneActive, isCameraActive,
     isGrabber, handRaised, onlyVideo, onlyAudio, mirror, videoClassName, audioClassName, mediaStream, title, toggleSingleFullScreen} : Props) => {
const [fontSize, setFontSize] = useState('');

    useEffect(() => {
        if(fullScreen){
            setFontSize("200%")
        } else {
            setFontSize("")
        }
},[fullScreen]);

const nameAndIconMask = () => {
    return(
        <>
            {handRaised === true && (
            <>
                <div
                style={{
                    position: 'absolute',
                    // bottom: firstLoad ? '5px' : '0px',
                    bottom: '0px',
                    right: '5px', // Posizionamento in basso a destra
                    padding: '5px',
                    zIndex: 1,
                    color: '#fff',
                    cursor: 'pointer',
                    fontSize: fontSize
                }}

                >
                    <i className={`fas fa-hand-paper optionButtonText`} style={{color: "#12ba3c", fontSize: "200%"}}></i>
                </div>
            </>
            )}
            {(isMicrophoneActive === false || isCameraActive === false) && (
            <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                position: 'absolute',
                // bottom: firstLoad ? '5px' : '0px',
                bottom: '0px',
                left: '5px', // Posizionamento in basso a sinistra
                padding: '5px',
                zIndex: 1,
                color: '#fff',
                cursor: 'pointer',
                fontSize: fontSize
                }}
            >
                {isMicrophoneActive === false && (
                <>
                    <div
                    style={{
                        marginRight: fullScreen ? '30px' : '5px',
                    //     position: 'absolute',
                    //     // bottom: firstLoad ? '5px' : '0px',
                    //     bottom: '0px',
                    //     left: '5px', // Posizionamento in basso a sinistra
                    //     padding: '5px',
                    //     zIndex: 1,
                    //     color: '#fff',
                    //     cursor: 'pointer',
                    //     fontSize: fontSize
                    }}

                    >
                        <i className={`fas fa-microphone-slash optionButtonText`}></i>
                    </div>
                </>
                )}
                {isCameraActive === false && (
                <>
                    <div
                    // style={{
                    //     position: 'absolute',
                    //     // bottom: firstLoad ? '5px' : '0px',
                    //     bottom: '0px',
                    //     left: '25%', // Posizionamento in basso a sinistra
                    //     padding: '5px',
                    //     zIndex: 1,
                    //     color: '#fff',
                    //     cursor: 'pointer',
                    //     fontSize: fontSize
                    // }}

                    >
                        <i className={`fas fa-video-slash optionButtonText`}></i>
                    </div>
                </>
                )}
            </div>
            )}
            {/* Aggiungi il nome in alto a sinistra */}
            <div style={{
                    position: 'absolute',
                    // top: firstLoad ? '5px' : '0px',
                    top: '5px',
                    left: '6px',
                    padding: '5px',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    color: '#fff',
                    zIndex: 1,
                    fontSize: '12px', // Carattere più piccolo
                    maxWidth: 'calc(100% - 10px)', // Massima larghezza per evitare lo sforamento
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                {title}
            </div>
        </>
    );
}
  return (
    <>
        {(mediaStream) && (
            <>
            {!onlyAudio ? 
            (
                <div
                    key={"video_" + user.stream.streamId}
                    id={isGrabber ? "Portrait_grabber_" + userId : "Portrait" + userId}
                    onDoubleClick={() => toggleSingleFullScreen ? toggleSingleFullScreen(isGrabber ? "Portrait_grabber_" + userId : "Portrait" + userId) : null}
                    className={videoClassName}
                    style={{overflow: 'hidden', width: '100%', height: '100%' }}
                >
                        <VideoPlayer id={"id_" + user.stream.streamId} mediaStream={mediaStream} fullScreen={fullScreen} onlyAudio={onlyAudio} onlyVideo={onlyVideo} mirror={mirror} mask={nameAndIconMask()}/>
                </div>
            ) : (
            <div 
            key={"audio_" + user.stream.streamId}
            id={isGrabber ? "GrabberAudioStream_" + userId : "AudioStream_" + userId}
            className={audioClassName}
            >
                {/* {webCamWithErrors && webCamWithErrors.findIndex(x => x === ("id_" + user.stream.streamId)) === -1 && ( */}
                    <VideoPlayer id={"id_" + user.stream.streamId} mediaStream={mediaStream} fullScreen={fullScreen}  onlyAudio={onlyAudio} onlyVideo={onlyVideo} mirror={mirror} />
                {/* )} */}
            </div >
        )}
        </>
        )}

  </>
  );
}

export default BroadcastStreamingContainer;